<template>
  <div>
    <!-- -->
    <el-card class="similar">
      <div class="similar-item" v-if="similarList.similarResource?.length">
        <div class="title">相似资源</div>
        <div class="flex-box">
          <div
            class="flex-item flex-item-1"
            v-for="item in similarList.similarResource"
            :key="item.imageId"
          >
            <el-image
              :src="item.imageUrl"
              fit="cover"
              :preview-src-list="
                similarList.similarResource.map((item) => item.imageUrl)
              "
              alt=""
            />
            <div :title="item.imageName">名称：{{ item.imageName }}</div>
            <div>相似度 {{ item.score }}%</div>
            <div :title="item.imageFrom">素材提供：{{ item.imageFrom }}</div>
          </div>
        </div>
      </div>
      <div class="similar-item" v-if="similarList.similarImage?.length">
        <div class="title">相似图片</div>
        <div class="flex-box">
          <div
            class="flex-item"
            v-for="item in similarList.similarImage"
            :key="item.imageId"
          >
            <el-image
              :src="item.imageUrl"
              fit="cover"
              :preview-src-list="
                similarList.similarImage.map((item) => item.imageUrl)
              "
              alt=""
            />
            <div :title="item.imageName">名称：{{ item.imageName }}</div>
            <div>相似度 {{ item.score }}%</div>
            <div :title="item.imageFrom">素材提供：{{ item.imageFrom }}</div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "SlbqWebSimilar",
  props: {
    similarList: {
      type: Object,
      default: () => {
        return {
          similarImage: [],
          similarResource: [],
        };
      },
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.similar {
  $border: 1px solid #dcdfe6;
  :deep(.el-card__body) {
    padding: 0;
  }
  &-item {
    border-left: $border;
    border-right: $border;
    &:last-child {
      border-bottom: $border;
    }
    .title {
      border-bottom: $border;
      border-top: $border;
      background: #ebf9fb;
      font-weight: bold;
      padding: 10px;
    }
  }
  .flex-box {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    /* display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 20px;
    grid-auto-rows: 1fr;
    grid-auto-columns: 1fr; */

    padding: 20px;
    .flex-item {
      width: calc(33.33% - 15px);
      min-width: 100px;
      font-size: 14px;
      line-height: 24px;
      div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-image {
        width: 100%;
        height: calc(100% - 90px);
        object-fit: cover;
        background: #fbfbfb;
        border-radius: 5px;
      }
    }
  }
}
</style>
